import { defineComponent as _defineComponent } from 'vue'
import CardSectionAwardsItem from './CardSectionAwardsItem.vue';

interface Props {
  awards: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionAwardsGrid',
  props: {
    awards: null
  },
  emits: ["item-click"],
  setup(__props: any) {




return { __sfc: true,CardSectionAwardsItem }
}

})